import React from 'react';
import { CheckIcon, XIcon, ArrowRightIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { TestimonialCard } from './TestimonialCard';
import { FAQAccordion } from './FAQAccordion';
const PURCHASE_LINK = 'https://pagos.digitalbibliotec.online/cart/47863223615742:1';
export function SalesPage() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = document.getElementById('comprar');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    const duration = 1500; // 1.5 seconds for a slower, more deliberate scroll
    let start: number | null = null;
    // easeInOutCubic easing function
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const animation = (currentTime: number) => {
      if (start === null) start = currentTime;
      const timeElapsed = currentTime - start;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutCubic(progress);
      window.scrollTo(0, startPosition + distance * ease);
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };
    requestAnimationFrame(animation);
  };
  const handlePurchase = () => {
    window.open(PURCHASE_LINK, '_blank');
  };
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-14">
      <CountdownTimer data-id="element-15" />
      <SocialProofPopup data-id="element-16" />

      {/* B) HERO SECTION */}
      <section className="bg-white pt-4 pb-6 px-4" data-id="element-17">
        <div className="max-w-4xl mx-auto text-center" data-id="element-18">
          <p className="text-red-600 font-bold tracking-wider uppercase text-xs mb-2" data-id="element-19">
            Atención Padres y Madres
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-3 leading-tight" data-id="element-20">
            Ser padre o madre cambió tu rutina.
          </h1>

          <div className="space-y-1 text-lg md:text-xl text-gray-700 font-medium mb-4" data-id="element-21">
            <p data-id="element-22">Tu cuerpo empezó a quedar en segundo plano.</p>
            <p data-id="element-23">Antes tenías más energía. Antes tu cuerpo respondía.</p>
            <p data-id="element-24">Pero hoy tu realidad es distinta.</p>
            <p data-id="element-25">Trabajo. Responsabilidades. Hijos. Cansancio.</p>
            <p data-id="element-26">Y sin darte cuenta…</p>
            <p data-id="element-27">tu cuerpo empezó a quedar último en la lista.</p>
          </div>

          <div className="bg-gray-100 p-3 rounded-xl mb-4 inline-block" data-id="element-28">
            <p className="text-base md:text-lg font-bold text-gray-800 mb-1" data-id="element-29">
              No es tu edad. No es falta de disciplina. Y tampoco es culpa de
              tus hijos.
            </p>
            <p className="text-base md:text-lg text-gray-700 mb-2" data-id="element-30">
              La verdad es más simple:
            </p>
            <p className="text-lg md:text-xl font-black text-red-600" data-id="element-31">
              👉 dejaste de tener un sistema que funcione con tu vida real.
            </p>
          </div>

          <div className="mb-4" data-id="element-32">
            <p className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-1" data-id="element-33">
              Entrenamiento + Nutrición Adaptados a Vida Real
            </p>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-2 uppercase tracking-tighter" data-id="element-34">
              SISTEMA PADRES FUERTE
            </h2>
            <span className="inline-block bg-yellow-400 text-black font-black px-4 py-1 rounded-full text-lg md:text-xl transform -rotate-2 shadow-sm" data-id="element-35">
              MEGAPACK COMPLETO
            </span>
          </div>

          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto mb-4" data-id="element-36">
            El sistema integral diseñado específicamente para padres y madres
            ocupados que quieren recuperar fuerza, energía y disciplina sin
            gimnasio, sin dietas extremas y sin abandonar a su familia.
          </p>

          <div className="mb-4 relative cursor-pointer group" onClick={scrollToPricing} data-id="element-37">
            <img src="https://cdn.magicpatterns.com/uploads/aUx8X56cgwv3FroN7AbhUz/MOCKUP_LISTO_PADRES_OCUPADOS.png" alt="Sistema Padres Fuerte Megapack Completo" className="w-full max-w-2xl mx-auto drop-shadow-xl transition-transform duration-300 group-hover:scale-105" data-id="element-38" />
          </div>

          <button onClick={scrollToPricing} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-black text-xl md:text-2xl py-4 px-6 rounded-xl shadow-xl animate-pulse-glow transition-all transform hover:-translate-y-1 flex items-center justify-center text-center mx-auto gap-2" data-id="element-39">
            👉 SÍ, QUIERO ACCEDER AHORA <ArrowRightIcon className="w-6 h-6" data-id="element-40" />
          </button>
        </div>
      </section>

      {/* C) PAIN POINT SECTION */}
      <section className="bg-gray-50 py-8 px-4 border-t border-gray-200" data-id="element-41">
        <div className="max-w-3xl mx-auto" data-id="element-42">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-3" data-id="element-43">
            Si sos padre o madre, dejame hacerte una pregunta honesta
          </h2>
          <p className="text-xl text-center font-bold text-red-600 mb-4" data-id="element-44">
            ¿Sentís que querés entrenar… pero tu vida no te lo permite?
          </p>

          <div className="space-y-2 text-lg text-gray-700 mb-4 text-center" data-id="element-45">
            <p data-id="element-46">No porque no quieras.</p>
            <p data-id="element-47">No porque no te importe tu salud.</p>
            <p data-id="element-48">No porque hayas perdido disciplina.</p>
            <p className="font-bold text-gray-900" data-id="element-49">
              Sino porque nadie te dio un método adaptado a tu realidad.
            </p>
          </div>

          <p className="text-xl font-bold mb-3 text-center" data-id="element-50">
            Intentaste entrenar, pero:
          </p>

          <div className="bg-white p-4 rounded-xl shadow-md mb-4" data-id="element-51">
            <ul className="space-y-2 text-base md:text-lg font-medium" data-id="element-52">
              <li className="flex items-center gap-2" data-id="element-53">
                <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-54" /> No
                tenés tiempo fijo
              </li>
              <li className="flex items-center gap-2" data-id="element-55">
                <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-56" /> Estás
                agotado/a
              </li>
              <li className="flex items-center gap-2" data-id="element-57">
                <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-58" /> Tu
                semana es impredecible
              </li>
              <li className="flex items-center gap-2" data-id="element-59">
                <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-60" /> Empezás
                y abandonás
              </li>
              <li className="flex items-center gap-2" data-id="element-61">
                <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-62" /> No
                querés cocinar diferente al resto
              </li>
              <li className="flex items-center gap-2" data-id="element-63">
                <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-64" /> No
                podés ir al gimnasio
              </li>
            </ul>
          </div>

          <p className="text-xl text-center italic font-medium text-gray-600" data-id="element-65">
            Y al final pensás:
            <br data-id="element-66" />
            <span className="font-bold text-gray-900" data-id="element-67">
              "Algún día, cuando tenga más tiempo…"
            </span>
          </p>
        </div>
      </section>

      {/* D) PROBLEM AGITATION */}
      <section className="bg-white py-8 px-4" data-id="element-68">
        <div className="max-w-3xl mx-auto" data-id="element-69">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-4" data-id="element-70">
            Entrenar no debería sentirse imposible.
          </h2>

          <p className="text-lg text-center mb-3" data-id="element-71">
            Pero cuando sos padre o madre, la mayoría de programas fitness
            simplemente no funcionan.
          </p>
          <p className="text-lg font-bold text-center mb-3" data-id="element-72">
            Porque están diseñados para personas que:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4" data-id="element-73">
            <div className="bg-gray-50 p-3 rounded-lg flex items-center gap-2 border border-gray-200" data-id="element-74">
              <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-75" />
              <span className="font-medium text-sm" data-id="element-76">
                Tienen horarios libres
              </span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg flex items-center gap-2 border border-gray-200" data-id="element-77">
              <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-78" />
              <span className="font-medium text-sm" data-id="element-79">
                Pueden entrenar 1 hora diaria
              </span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg flex items-center gap-2 border border-gray-200" data-id="element-80">
              <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-81" />
              <span className="font-medium text-sm" data-id="element-82">Pueden ir al gimnasio</span>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg flex items-center gap-2 border border-gray-200" data-id="element-83">
              <XIcon className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-84" />
              <span className="font-medium text-sm" data-id="element-85">
                No tienen interrupciones
              </span>
            </div>
          </div>

          <p className="text-xl text-center font-bold mb-3" data-id="element-86">
            Tu realidad es distinta.
          </p>
          <p className="text-lg text-center mb-4" data-id="element-87">
            Y ahí aparece el verdadero problema.
          </p>

          <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4" data-id="element-88">
            <p className="text-lg font-black text-red-700" data-id="element-89">
              👉 El problema no son tus hijos. El problema es no tener
              estructura.
            </p>
          </div>

          <p className="text-lg font-bold mb-3 text-center" data-id="element-90">
            Si sos padre o madre ocupado/a, esto te resulta familiar:
          </p>

          <div className="bg-white border border-gray-200 p-4 rounded-xl shadow-sm mb-4" data-id="element-91">
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4 text-base font-medium" data-id="element-92">
              <li className="flex items-center gap-2" data-id="element-93">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-94" /> Caos en
                los horarios
              </li>
              <li className="flex items-center gap-2" data-id="element-95">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-96" /> Falta
                de energía
              </li>
              <li className="flex items-center gap-2" data-id="element-97">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-98" /> Dolor
                lumbar o rigidez
              </li>
              <li className="flex items-center gap-2" data-id="element-99">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-100" /> Culpa
                por no priorizarte
              </li>
              <li className="flex items-center gap-2" data-id="element-101">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-102" /> Dietas
                que duran pocos días
              </li>
              <li className="flex items-center gap-2" data-id="element-103">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-104" /> Falta
                de constancia
              </li>
            </ul>
          </div>

          <div className="text-center" data-id="element-105">
            <p className="text-lg mb-1" data-id="element-106">Y lo peor no es solo el físico.</p>
            <p className="text-xl font-black text-gray-900" data-id="element-107">
              Es la sensación de haber perdido una parte tuya.
            </p>
          </div>
        </div>
      </section>

      {/* E) SOLUTION SECTION */}
      <section className="bg-green-50 py-8 px-4 border-y border-green-200" data-id="element-108">
        <div className="max-w-4xl mx-auto text-center" data-id="element-109">
          <div className="inline-flex items-center justify-center gap-1 bg-green-600 text-white px-4 py-1 rounded-full font-bold text-sm mb-4 shadow-sm" data-id="element-110">
            <CheckIcon className="w-4 h-4" data-id="element-111" /> LA SOLUCIÓN
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-112">
            SISTEMA PADRES FUERTE – MEGAPACK COMPLETO
          </h2>

          <p className="text-lg text-gray-700 font-medium mb-6" data-id="element-113">
            Un sistema claro, progresivo y adaptable a semanas caóticas.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-6" data-id="element-114">
            <div className="flex flex-col items-center" data-id="element-115">
              <div className="text-4xl mb-1" data-id="element-116">📂</div>
              <p className="font-bold text-base" data-id="element-117">Abrís el material</p>
            </div>
            <ArrowRightIcon className="hidden md:block w-6 h-6 text-green-400" data-id="element-118" />
            <div className="flex flex-col items-center" data-id="element-119">
              <div className="text-4xl mb-1" data-id="element-120">👆</div>
              <p className="font-bold text-base" data-id="element-121">Elegís tu etapa</p>
            </div>
            <ArrowRightIcon className="hidden md:block w-6 h-6 text-green-400" data-id="element-122" />
            <div className="flex flex-col items-center" data-id="element-123">
              <div className="text-4xl mb-1" data-id="element-124">✏️</div>
              <p className="font-bold text-base" data-id="element-125">Aplicás el plan</p>
            </div>
          </div>

          <p className="text-lg font-black text-gray-900 mb-6 bg-white inline-block px-4 py-2 rounded-lg shadow-sm border border-green-100" data-id="element-126">
            Sin gimnasio. Sin horarios rígidos. Sin improvisar.
          </p>

          <button onClick={scrollToPricing} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-black text-xl py-4 px-6 rounded-xl shadow-xl transition-all transform hover:-translate-y-1 mx-auto flex items-center justify-center text-center" data-id="element-127">
            👉 QUIERO RECUPERAR MI ENERGÍA AHORA
          </button>
        </div>
      </section>

      {/* J) EXTRA STRATEGIC CTA */}
      <section className="bg-gray-900 py-6 px-4" data-id="element-128">
        <div className="max-w-4xl mx-auto text-center" data-id="element-129">
          <button onClick={scrollToPricing} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-black text-lg md:text-xl py-4 px-6 rounded-xl shadow-xl animate-pulse-glow transition-all transform hover:-translate-y-1 mx-auto flex items-center justify-center text-center" data-id="element-130">
            🔥 QUIERO TRANSFORMAR MI CUERPO HOY → Acceder al Sistema
          </button>
        </div>
      </section>

      {/* F) WHAT'S INCLUDED */}
      <section className="bg-white py-8 px-4" data-id="element-131">
        <div className="max-w-5xl mx-auto" data-id="element-132">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-6" data-id="element-133">
            📘 ¿Qué incluye exactamente el MEGAPACK COMPLETO?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-134">
            {/* Tomo 1 */}
            <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow relative overflow-hidden" data-id="element-135">
              <div className="absolute top-0 left-0 w-1 h-full bg-blue-500" data-id="element-136"></div>
              <h3 className="text-xl font-black mb-1 flex items-center gap-2" data-id="element-137">
                <span className="text-2xl" data-id="element-138">🧠</span> TOMO 1 – MENTE FUERTE EN
                VIDA REAL
              </h3>
              <p className="text-gray-500 italic text-sm mb-3" data-id="element-139">
                La base que casi nadie enseña.
              </p>
              <ul className="space-y-1 mb-4 text-sm" data-id="element-140">
                <li className="flex items-start gap-2" data-id="element-141">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-142" />{' '}
                  Cómo entrenar en semanas impredecibles
                </li>
                <li className="flex items-start gap-2" data-id="element-143">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-144" />{' '}
                  Sistema anti-abandono
                </li>
                <li className="flex items-start gap-2" data-id="element-145">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-146" />{' '}
                  Mentalidad de padre/madre fuerte
                </li>
                <li className="flex items-start gap-2" data-id="element-147">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-148" />{' '}
                  Cómo instalar disciplina real
                </li>
              </ul>
              <div className="bg-blue-50 p-2 rounded-md" data-id="element-149">
                <p className="font-bold text-blue-900 text-sm" data-id="element-150">
                  👉 Eliminás excusas. Instalás estructura.
                </p>
              </div>
            </div>

            {/* Tomo 2 */}
            <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow relative overflow-hidden" data-id="element-151">
              <div className="absolute top-0 left-0 w-1 h-full bg-red-500" data-id="element-152"></div>
              <h3 className="text-xl font-black mb-3 flex items-center gap-2" data-id="element-153">
                <span className="text-2xl" data-id="element-154">💪</span> TOMO 2 – FUERZA EXPRESS EN
                CASA
              </h3>
              <ul className="space-y-1 mb-4 text-sm" data-id="element-155">
                <li className="flex items-start gap-2" data-id="element-156">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-157" />{' '}
                  Rutinas paso a paso
                </li>
                <li className="flex items-start gap-2" data-id="element-158">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-159" />{' '}
                  Entrenamientos de solo 20 minutos
                </li>
                <li className="flex items-start gap-2" data-id="element-160">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-161" />{' '}
                  Sin equipamiento
                </li>
                <li className="flex items-start gap-2" data-id="element-162">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-163" />{' '}
                  Sin experiencia previa
                </li>
              </ul>
              <div className="bg-red-50 p-2 rounded-md mt-auto" data-id="element-164">
                <p className="font-bold text-red-900 text-sm" data-id="element-165">
                  👉 Entrenamiento real para personas con poco tiempo.
                </p>
              </div>
            </div>

            {/* Tomo 3 */}
            <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow relative overflow-hidden" data-id="element-166">
              <div className="absolute top-0 left-0 w-1 h-full bg-purple-500" data-id="element-167"></div>
              <h3 className="text-xl font-black mb-3 flex items-center gap-2" data-id="element-168">
                <span className="text-2xl" data-id="element-169">⚙️</span> TOMO 3 – PROGRESIÓN
                INTELIGENTE 8 SEMANAS
              </h3>
              <ul className="space-y-1 mb-4 text-sm" data-id="element-170">
                <li className="flex items-start gap-2" data-id="element-171">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-172" />{' '}
                  Adaptación inicial
                </li>
                <li className="flex items-start gap-2" data-id="element-173">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-174" />{' '}
                  Progresión estructurada
                </li>
                <li className="flex items-start gap-2" data-id="element-175">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-176" />{' '}
                  Consolidación de hábitos
                </li>
              </ul>
              <div className="bg-purple-50 p-2 rounded-md mt-auto" data-id="element-177">
                <p className="font-bold text-purple-900 text-sm" data-id="element-178">
                  👉 Resultados reales sin abandonar.
                </p>
              </div>
            </div>

            {/* Tomo 4 */}
            <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow relative overflow-hidden" data-id="element-179">
              <div className="absolute top-0 left-0 w-1 h-full bg-green-500" data-id="element-180"></div>
              <h3 className="text-xl font-black mb-3 flex items-center gap-2" data-id="element-181">
                <span className="text-2xl" data-id="element-182">🥗</span> TOMO 4 – NUTRICIÓN FAMILIAR
                INTELIGENTE
              </h3>
              <ul className="space-y-1 mb-4 text-sm" data-id="element-183">
                <li className="flex items-start gap-2" data-id="element-184">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-185" />{' '}
                  Comer lo mismo que tu familia
                </li>
                <li className="flex items-start gap-2" data-id="element-186">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-187" />{' '}
                  Sin cocinar doble
                </li>
                <li className="flex items-start gap-2" data-id="element-188">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-189" />{' '}
                  Planificación simple
                </li>
                <li className="flex items-start gap-2" data-id="element-190">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-191" />{' '}
                  Alimentación sostenible
                </li>
              </ul>
              <div className="bg-green-50 p-2 rounded-md mt-auto" data-id="element-192">
                <p className="font-bold text-green-900 text-sm" data-id="element-193">
                  👉 Sin dietas extremas.
                </p>
              </div>
            </div>

            {/* Tomo 5 */}
            <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow relative overflow-hidden" data-id="element-194">
              <div className="absolute top-0 left-0 w-1 h-full bg-yellow-500" data-id="element-195"></div>
              <h3 className="text-xl font-black mb-3 flex items-center gap-2" data-id="element-196">
                <span className="text-2xl" data-id="element-197">🔄</span> TOMO 5 – ENERGÍA Y
                CONSTANCIA
              </h3>
              <ul className="space-y-1 mb-4 text-sm" data-id="element-198">
                <li className="flex items-start gap-2" data-id="element-199">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-200" />{' '}
                  Micro-hábitos poderosos
                </li>
                <li className="flex items-start gap-2" data-id="element-201">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-202" />{' '}
                  Ritual semanal de 10 minutos
                </li>
                <li className="flex items-start gap-2" data-id="element-203">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-204" />{' '}
                  Sistema anti-abandono
                </li>
              </ul>
              <div className="bg-yellow-50 p-2 rounded-md mt-auto" data-id="element-205">
                <p className="font-bold text-yellow-900 text-sm" data-id="element-206">
                  👉 Energía estable incluso en semanas difíciles.
                </p>
              </div>
            </div>

            {/* Tomo 6 */}
            <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-shadow relative overflow-hidden" data-id="element-207">
              <div className="absolute top-0 left-0 w-1 h-full bg-orange-500" data-id="element-208"></div>
              <h3 className="text-xl font-black mb-3 flex items-center gap-2" data-id="element-209">
                <span className="text-2xl" data-id="element-210">🏠</span> TOMO 6 – HOGAR FUERTE
              </h3>
              <ul className="space-y-1 mb-4 text-sm" data-id="element-211">
                <li className="flex items-start gap-2" data-id="element-212">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-213" />{' '}
                  Cultura de movimiento en casa
                </li>
                <li className="flex items-start gap-2" data-id="element-214">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-215" />{' '}
                  Juegos activos con hijos
                </li>
                <li className="flex items-start gap-2" data-id="element-216">
                  <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-217" />{' '}
                  Liderazgo con ejemplo
                </li>
              </ul>
              <div className="bg-orange-50 p-2 rounded-md mt-auto" data-id="element-218">
                <p className="font-bold text-orange-900 text-sm" data-id="element-219">
                  👉 No solo cambiás vos. Cambia tu hogar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* G) BEFORE VS AFTER */}
      <section className="bg-black py-8 px-4 text-white" data-id="element-220">
        <div className="max-w-5xl mx-auto" data-id="element-221">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-6" data-id="element-222">
            🔄 Antes vs Después
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-223">
            {/* Antes */}
            <div className="bg-gray-900 border border-red-900 rounded-xl p-5 relative overflow-hidden" data-id="element-224">
              <div className="absolute top-0 left-0 w-full h-1 bg-red-600" data-id="element-225"></div>
              <h3 className="text-xl font-black text-red-500 mb-4 text-center uppercase tracking-wider" data-id="element-226">
                Antes del Sistema
              </h3>
              <ul className="space-y-2 text-base" data-id="element-227">
                <li className="flex items-center gap-3" data-id="element-228">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-229" />{' '}
                  Cansancio constante
                </li>
                <li className="flex items-center gap-3" data-id="element-230">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-231" />{' '}
                  Entrenamiento improvisado
                </li>
                <li className="flex items-center gap-3" data-id="element-232">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-233" />{' '}
                  Dietas que duran poco
                </li>
                <li className="flex items-center gap-3" data-id="element-234">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-235" /> Falta
                  de estructura
                </li>
                <li className="flex items-center gap-3" data-id="element-236">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-237" /> Culpa
                </li>
                <li className="flex items-center gap-3" data-id="element-238">
                  <XIcon className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-239" /> Dolor
                  físico
                </li>
              </ul>
            </div>

            {/* Después */}
            <div className="bg-gray-900 border border-green-900 rounded-xl p-5 relative overflow-hidden" data-id="element-240">
              <div className="absolute top-0 left-0 w-full h-1 bg-green-500" data-id="element-241"></div>
              <h3 className="text-xl font-black text-green-400 mb-4 text-center uppercase tracking-wider" data-id="element-242">
                Después del Sistema
              </h3>
              <ul className="space-y-2 text-base" data-id="element-243">
                <li className="flex items-center gap-3" data-id="element-244">
                  <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-245" />{' '}
                  Energía diaria
                </li>
                <li className="flex items-center gap-3" data-id="element-246">
                  <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-247" />{' '}
                  Entrenamiento claro
                </li>
                <li className="flex items-center gap-3" data-id="element-248">
                  <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-249" />{' '}
                  Rutinas de 20 minutos
                </li>
                <li className="flex items-center gap-3" data-id="element-250">
                  <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-251" />{' '}
                  Nutrición entendida
                </li>
                <li className="flex items-center gap-3" data-id="element-252">
                  <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-253" />{' '}
                  Confianza
                </li>
                <li className="flex items-center gap-3" data-id="element-254">
                  <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-255" />{' '}
                  Cultura familiar activa
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* H) BONUSES SECTION */}
      <section className="bg-gray-50 py-8 px-4 border-b border-gray-200" data-id="element-256">
        <div className="max-w-4xl mx-auto" data-id="element-257">
          <div className="text-center mb-6" data-id="element-258">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-2 uppercase" data-id="element-259">
              🎁 BONOS ESPECIALES
            </h2>
            <p className="text-xl font-bold text-red-600 bg-red-100 inline-block px-4 py-1 rounded-full" data-id="element-260">
              GRATIS HOY
            </p>
          </div>

          {/* Bono 1 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden mb-6 border-2 border-yellow-400 flex flex-col md:flex-row" data-id="element-261">
            <div className="md:w-1/2 bg-gray-100 p-4 flex items-center justify-center cursor-pointer" onClick={scrollToPricing} data-id="element-262">
              <img src="https://cdn.magicpatterns.com/uploads/jaaDVeEXBygQYGAb4fbaLm/Diseno_sin_titulo_(3).png" alt="Planner Familiar Fitness" className="w-full aspect-square object-contain max-w-[540px] drop-shadow-xl hover:scale-105 transition-transform" data-id="element-263" />
            </div>
            <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center" data-id="element-264">
              <h3 className="text-2xl font-black text-gray-900 mb-1" data-id="element-265">
                🎁 BONO 1
              </h3>
              <h4 className="text-xl font-bold text-gray-800 mb-3" data-id="element-266">
                PLANNER FAMILIAR FITNESS
              </h4>
              <div className="flex items-center gap-2 mb-4" data-id="element-267">
                <span className="text-sm text-gray-500 line-through" data-id="element-268">
                  Valor: ARS $18.000
                </span>
                <span className="bg-green-100 text-green-700 font-black px-3 py-1 rounded-full text-sm" data-id="element-269">
                  HOY: GRATIS
                </span>
              </div>
              <ul className="space-y-2 text-base" data-id="element-270">
                <li className="flex items-start gap-2" data-id="element-271">
                  <CheckIcon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-272" />{' '}
                  Organización semanal en 10 minutos
                </li>
                <li className="flex items-start gap-2" data-id="element-273">
                  <CheckIcon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-274" />{' '}
                  Reducción de estrés
                </li>
                <li className="flex items-start gap-2" data-id="element-275">
                  <CheckIcon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-276" />{' '}
                  Control visual de progreso
                </li>
                <li className="flex items-start gap-2" data-id="element-277">
                  <CheckIcon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-278" />{' '}
                  Plan imprimible
                </li>
              </ul>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border-2 border-yellow-400 flex flex-col md:flex-row-reverse" data-id="element-279">
            <div className="md:w-1/2 bg-gray-100 p-4 flex items-center justify-center cursor-pointer" onClick={scrollToPricing} data-id="element-280">
              <img src="https://cdn.magicpatterns.com/uploads/g2FvVGHYSoHAxY9uowPMH7/Diseno_sin_titulo_(4).png" alt="Menú Familiar Inteligente" className="w-full aspect-square object-contain max-w-[540px] drop-shadow-xl hover:scale-105 transition-transform" data-id="element-281" />
            </div>
            <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center" data-id="element-282">
              <h3 className="text-2xl font-black text-gray-900 mb-1" data-id="element-283">
                🎁 BONO 2
              </h3>
              <h4 className="text-xl font-bold text-gray-800 mb-3" data-id="element-284">
                MENÚ FAMILIAR INTELIGENTE – 7 DÍAS
              </h4>
              <div className="flex items-center gap-2 mb-4" data-id="element-285">
                <span className="text-sm text-gray-500 line-through" data-id="element-286">
                  Valor: Invaluable
                </span>
                <span className="bg-green-100 text-green-700 font-black px-3 py-1 rounded-full text-sm" data-id="element-287">
                  HOY: GRATIS
                </span>
              </div>
              <ul className="space-y-2 text-base" data-id="element-288">
                <li className="flex items-start gap-2" data-id="element-289">
                  <CheckIcon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-290" />{' '}
                  Menú completo listo para aplicar
                </li>
                <li className="flex items-start gap-2" data-id="element-291">
                  <CheckIcon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-292" />{' '}
                  Lista de compras incluida
                </li>
                <li className="flex items-start gap-2" data-id="element-293">
                  <CheckIcon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-294" />{' '}
                  Opciones adaptables
                </li>
                <li className="flex items-start gap-2" data-id="element-295">
                  <CheckIcon className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-296" />{' '}
                  Sin comidas especiales separadas
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* I) PACKAGE SUMMARY + PRICING */}
      <section id="comprar" className="bg-white py-8 px-4" data-id="element-297">
        <div className="max-w-3xl mx-auto" data-id="element-298">
          <div className="border-4 border-yellow-400 rounded-2xl p-4 md:p-6 shadow-xl relative" data-id="element-299">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-yellow-400 text-black font-black px-6 py-1 rounded-full text-lg shadow-sm" data-id="element-300">
              OFERTA ESPECIAL
            </div>

            <h2 className="text-2xl md:text-3xl font-black text-center mb-4 mt-3" data-id="element-301">
              📦 Lo que recibís hoy
            </h2>

            <div className="bg-gray-50 rounded-xl p-4 mb-4 border border-gray-200" data-id="element-302">
              <ul className="space-y-2 text-lg font-medium" data-id="element-303">
                <li className="flex items-center gap-2" data-id="element-304">
                  <CheckIcon className="w-5 h-5 text-green-500" data-id="element-305" /> 📘 6 Tomos
                  completos
                </li>
                <li className="flex items-center gap-2" data-id="element-306">
                  <CheckIcon className="w-5 h-5 text-green-500" data-id="element-307" /> 🎁 2 Bonos
                  exclusivos
                </li>
                <li className="flex items-center gap-2" data-id="element-308">
                  <CheckIcon className="w-5 h-5 text-green-500" data-id="element-309" /> 📂 Sistema
                  estructurado 8 semanas
                </li>
                <li className="flex items-center gap-2" data-id="element-310">
                  <CheckIcon className="w-5 h-5 text-green-500" data-id="element-311" /> ⚡ Acceso
                  inmediato
                </li>
                <li className="flex items-center gap-2" data-id="element-312">
                  <CheckIcon className="w-5 h-5 text-green-500" data-id="element-313" /> 💻 Descarga
                  digital
                </li>
                <li className="flex items-center gap-2" data-id="element-314">
                  <CheckIcon className="w-5 h-5 text-green-500" data-id="element-315" /> ♾️ Acceso de
                  por vida
                </li>
              </ul>
            </div>

            <div className="text-center mb-6" data-id="element-316">
              <p className="text-xl text-gray-500 line-through mb-1 font-medium" data-id="element-317">
                Precio regular: ARS $39.990
              </p>
              <p className="text-4xl md:text-5xl font-black text-red-600 mb-1" data-id="element-318">
                🔥 HOY SOLO:
              </p>
              <p className="text-5xl md:text-6xl font-black text-green-600" data-id="element-319">
                ARS $15.990
              </p>
            </div>

            <button onClick={handlePurchase} className="w-full bg-green-600 hover:bg-green-700 text-white font-black text-xl md:text-2xl py-4 px-4 rounded-xl shadow-xl animate-pulse-glow transition-all transform hover:-translate-y-1 mb-4 flex items-center justify-center text-center gap-2" data-id="element-320">
              👉 OBTENER MI MEGAPACK COMPLETO AHORA
            </button>

            <div className="text-center" data-id="element-321">
              <p className="text-gray-600 font-medium text-base mb-1" data-id="element-322">
                Mastercard • Visa • Mercado Pago
              </p>
              <p className="text-green-600 font-bold flex items-center justify-center gap-1 text-sm" data-id="element-323">
                <CheckIcon className="w-4 h-4" data-id="element-324" /> Pago 100% Seguro
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* K) TESTIMONIALS SECTION */}
      <section className="bg-gray-100 py-8 px-4" data-id="element-325">
        <div className="max-w-6xl mx-auto" data-id="element-326">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-6" data-id="element-327">
            💬 Lo que dicen padres y madres como vos
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-328">
            <TestimonialCard name="Martín" age={38} quote="Pensé que ya no tenía tiempo para entrenar. Este sistema me devolvió estructura." data-id="element-329" />
            <TestimonialCard name="Laura" age={34} quote="Pude entrenar sin dejar a mis hijos de lado." data-id="element-330" />
            <TestimonialCard name="Nicolás" age={41} quote="Por primera vez no abandoné a la semana 3." data-id="element-331" />
            <TestimonialCard name="Florencia" age={36} quote="Después de mi segundo hijo, sentí que mi cuerpo ya no era el mismo. Con este sistema volví a sentirme fuerte y con energía para todo." data-id="element-332" />
            <TestimonialCard name="Rodrigo" age={42} quote="Lo mejor es que puedo comer lo mismo que mi familia. No más dietas raras ni cocinar doble." data-id="element-333" />
          </div>
        </div>
      </section>

      {/* L) FAQ SECTION */}
      <section className="bg-white py-8 px-4" data-id="element-334">
        <div className="max-w-4xl mx-auto" data-id="element-335">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-6" data-id="element-336">
            ❓ Preguntas frecuentes
          </h2>
          <FAQAccordion data-id="element-337" />
        </div>
      </section>

      {/* M) FINAL CTA SECTION */}
      <section className="bg-black text-white py-10 px-4 text-center" data-id="element-338">
        <div className="max-w-3xl mx-auto" data-id="element-339">
          <h2 className="text-2xl md:text-3xl font-black mb-4" data-id="element-340">
            Entrenar siendo padre o madre puede ser más simple.
          </h2>

          <p className="text-lg mb-2" data-id="element-341">
            No necesitás más motivación. No necesitás esperar el momento
            perfecto.
          </p>
          <p className="text-xl font-bold text-yellow-400 mb-4" data-id="element-342">
            👉 Necesitás un sistema que funcione incluso cuando estás cansado.
          </p>

          <p className="text-xl font-black mb-6" data-id="element-343">
            Recuperá fuerza. Recuperá energía. Recuperá tu identidad.
          </p>

          <div className="mb-6" data-id="element-344">
            <p className="text-lg font-bold mb-1" data-id="element-345">👉 ACCEDÉ AHORA A</p>
            <p className="text-2xl md:text-3xl font-black text-yellow-400 uppercase" data-id="element-346">
              SISTEMA PADRES FUERTE – MEGAPACK COMPLETO
            </p>
          </div>

          <button onClick={scrollToPricing} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-black text-xl md:text-2xl py-4 px-6 rounded-xl shadow-xl animate-pulse-glow transition-all transform hover:-translate-y-1 mb-8 mx-auto flex items-center justify-center text-center" data-id="element-347">
            👉 SÍ, QUIERO ACCEDER AHORA
          </button>

          <div className="border-t border-gray-800 pt-6" data-id="element-348">
            <p className="text-xl md:text-2xl font-medium mb-2" data-id="element-349">
              Tus hijos no necesitan padres perfecto
            </p>
            <p className="text-2xl md:text-3xl font-black text-white" data-id="element-350">
              Necesitan uno fuerte.
            </p>
            <p className="text-xl font-bold text-gray-400 mt-3" data-id="element-351">
              Y eso empieza hoy.
            </p>
          </div>
        </div>
      </section>
    </div>;
}